import * as Yup from 'yup';
export const toOptionalNumber = (
  schema: Yup.NumberSchema<number | undefined>
) =>
  schema.transform((val, orig) =>
    orig === '' || orig === null ? undefined : val
  );

const requiredText = () => Yup.string().trim().required('Required');

export const marineValidationSchema = () =>
  Yup.object({
    marineDetails: Yup.object({
      matterID: requiredText(),
      description: requiredText(),
      vessalName: requiredText(),
      departureFrom: requiredText(),
      departureTo: requiredText(),
      transportationVia: requiredText(),
      survey: requiredText(),
      cargoContract: requiredText(),
      sumPerShipmentCurrencyID: requiredText(),

      sumPerShipment: toOptionalNumber(
        Yup.number()
          .typeError('Invalid Number')
          .min(0, 'Value should be greater than 0')
          .required('Required')
      ),

      claimsPayableBy: requiredText(),

      loading: Yup.number()
        .typeError('Invalid Number')
        .min(0, 'Invalid Loading Percentage')
        .max(100, 'Invalid Loading Percentage')
        .required('Required'),

      vesselAge: toOptionalNumber(
        Yup.number()
          .typeError('Invalid Vessel Age')
          .min(0, 'Invalid Vessel Age')
      ),

      bank: Yup.string().trim().notRequired(),
      lcNumber: Yup.string().trim().notRequired(),
      lcIssueDate: Yup.string().trim().notRequired(),
      remarks: Yup.string().trim().notRequired()
    })
  });
